import { projectMedia } from './sharedMedia';

/**
 * All project reels use the shared luca-miro projects media folder.
 * (Compressed locals replaced former Cloudflare R2 / media.winccards.ai URLs.)
 */
const projectVideos = {
  'curse-of-the-nile': projectMedia('Curse of the Nile', 'Curse of the Nile 24.mp4'),
  deadzone: projectMedia('Deadzone', 'DeadZone Experience 24.mp4'),
  skywar: projectMedia('Skywar', 'SkyWar 24.mp4'),
  'midnight-manor': projectMedia('Midnight Manor', 'Midnight Manor.mp4'),
  'vampire-hotel': projectMedia('videos', 'Vampire Hotel 24.mp4'),
  locanda: projectMedia('Locanda', 'Locanda Happiness 24.MP4'),
  'a-lot-like-life': projectMedia('Alotlikelife', 'Alot Like Life 24.mp4'),
  howling: projectMedia('videos', 'Howling.mp4'),
  'music-hell': projectMedia('videos', 'MusicHell.mp4'),
  'pubg-mobile': projectMedia('videos', 'PubgMobile.mp4'),
  'italian-hotel': projectMedia('videos', 'ItalianHotel.mp4'),
  'horror-movie-house': projectMedia('videos', 'HorrorMovieHouse.mp4'),
  'dart-zone': projectMedia('videos', 'Global City Dart zone 25.mp4'),
  'the-dark': projectMedia('videos', 'Global City The Dark.mp4'),
  'mummy-quest': projectMedia('videos', 'Mummy Quest walkthrough 23.mp4'),
  'rasha-rizk': projectMedia('videos', 'Rasha Rizq Spacetoon 26.mp4'),
  'poppy-playtime': projectMedia('videos', 'Poppy Playtime.mp4'),
  'luca-park': projectMedia('videos', 'Lucapark 24.mp4'),
  horrorcon: projectMedia('Horrorcon', 'Horrorcon.mp4'),
  karting: projectMedia('Karting', 'karting.mp4'),
};

const projectVideoKind = {
  'curse-of-the-nile': 'mp4',
  deadzone: 'mp4',
  skywar: 'mp4',
  'midnight-manor': 'mp4',
  locanda: 'mp4',
};

/** Return project video only — never substitute another project's reel. */
export function getProjectVideo(slug) {
  if (slug == null || slug === '') return null;
  if (!Object.prototype.hasOwnProperty.call(projectVideos, slug)) return null;
  const src = projectVideos[slug];
  if (src === '' || src == null) return null;
  return src;
}

/** Video for gallery modal only — no generic fallback when slug is unknown */
export function getProjectGalleryVideo(slug) {
  if (slug == null || slug === '') return null;
  if (!Object.prototype.hasOwnProperty.call(projectVideos, slug)) return null;
  const src = projectVideos[slug];
  if (src === '' || src == null) return null;
  return src;
}

export function isQuickTimeProjectVideo(slug) {
  return projectVideoKind[slug] === 'quicktime';
}

export function getVideoMimeType(src) {
  const lower = String(src).toLowerCase();
  if (lower.includes('.mov')) return 'video/quicktime';
  if (lower.includes('.webm')) return 'video/webm';
  if (lower.startsWith('http://') || lower.startsWith('https://')) return 'video/mp4';
  return 'video/mp4';
}
